var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('model',{attrs:{"width":"auto","title":"v1.0.2","tag":"2024-01-02"}},[_c('div',{staticClass:"lh-icon-logo",style:({fontSize:_vm.logoFontSize})},[_c('span',{style:({fontSize:_vm.titleFontSize})},[_vm._v("lhUI")])]),_c('div',{staticClass:"foot"},[_vm._v(" Hello world! "),_c('br'),_vm._v(" 第一个正式版本"),_c('br'),_vm._v(" author:两行 ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }